import './App.css';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Homepage from './components/Homepage';
import Contact from './components/Contact';
import Aboutus from './components/Aboutus';
import RealEstatePage from './components/sector-pages/RealEstatePage';
import FinacialSector from './components/sector-pages/FinancialSector';
import TransportSector from './components/sector-pages/TransportSector';
import ManufacturingSector from './components/sector-pages/ManufacturingSector';
import EducationSector from './components/sector-pages/EducationSector';
import EnergyandMaterialSector from './components/sector-pages/EnergyandMaterialSector';
import FoodSector from './components/sector-pages/FoodSector';
import ScrollToTop from './ScrollToTop';
import "./components/Translation/i18n"; 

function App() {
  return (
    <Router>
      <Navbar />
      <ScrollToTop/>
      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path='/contact' element={<Contact/>}/>
        <Route path='/about' element={<Aboutus/>} />
        <Route path="/realestate" element={<RealEstatePage/>}/>
        <Route path='/financial' element={<FinacialSector/>}/>
        <Route path='/transport' element={<TransportSector/>}/>
        <Route path='/manufacturing' element={<ManufacturingSector/>}/>
        <Route path='/education' element={<EducationSector/>}/>
        <Route path='/energyandmaterial' element={<EnergyandMaterialSector/>}/>
        <Route path='/food' element={<FoodSector/>}/>
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
